import React from 'react';
import { Group, Skeleton as MaestroSkeleton, ButtonSize } from '@landr/maestro';

const Skeleton = ({ buttonSize }: { buttonSize: ButtonSize }) => {
    const size = buttonSize === 'md' ? '48px' : '36px';

    return (
        <Group gutter="xs" aria-busy="true">
            <Group.Item>
                <MaestroSkeleton height={size} width={size} variant="round" />
            </Group.Item>
            <Group.Item>
                <MaestroSkeleton height={size} width={size} variant="round" />
            </Group.Item>
        </Group>
    );
};

export default Skeleton;
